<template>
  <form @submit.prevent="submit">
    <fields
      :fields="fields.except('agree')"
      :model="model"
      :errors="errors"
      layout="nolabel"
    />
    <div attribute="agree" class="form-group">
      <div class="custom-control custom-checkbox">
        <input
          id="agree"
          v-model="model.agree"
          type="checkbox"
          class="custom-control-input"
        />
        <label
          for="agree"
          class="custom-control-label check-text"
          v-html="fields.get('agree').label"
        />
        <div v-if="errors.errors.agree" class="invalid-feedback d-block">
          {{ errors.errors.agree.toString() }}
        </div>
      </div>
    </div>
    <input type="submit" :value="$t('Registration')" class="reg-btn mt-35" />
  </form>
</template>

<script>
import { FormMixin } from "stylemix-base";
import LanguageMixin from "../mixins/LanguageMixin";
import Swal from "sweetalert2";

export default {
  name: "Register",
  mixins: [FormMixin, LanguageMixin],

  data() {
    return {
      model: window.REGISTER.data,
    };
  },

  created() {
    this.setFields(window.REGISTER.fields);

    let keys = ["email", "password", "last_name", "first_name", "location"];

    keys.forEach((key) => {
      let field = this.fields.get(key);
      field.placeholder = this.$t(field.label);
    });
  },

  methods: {
    submit() {
      this.errors.clear();
      this.$http
        .post("auth/register", this.model)
        .then((response) => {
          this.$toast.success(this.$t("Successfully registered"));
          let accountUrl = "/account";

          if (this.lang) {
            accountUrl = `/${this.language}${accountUrl}`;
          }

          setTimeout(() => {
            window.location.href = accountUrl;
          }, 5000);
        })
        .catch((rejection) => {
          if (rejection.response && rejection.response.status === 422) {
            this.setValidationErrors(rejection.response.data.errors);

            let message = "";
            for (var error in rejection.response.data.errors) {
              message +=
                rejection.response.data.errors[error].join("\r\n") + "\r\n";
            }

            Swal.fire({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              html: message,
              type: "error",
              timer: 5000,
            });
          }
        });
    },
  },
};
</script>
